import React, { useCallback } from 'react';
import classNames from 'classnames';
import { Provider, useApiIntegrations } from 'src/common/api/use-integrations.hook';
import { openPopupWindow } from 'src/utils/window';
import { NeueJourneyButton } from '../components/neue-button/journey';

import { integrations } from 'src/utils/integration/providers';
import { NeueButtonBase } from '../components/neue-button/base';
import { GongIntegrationIcon, GoogleDriveIntegrationIcon } from 'src/monet/icons';
import DropboxIntegrationIcon from 'src/monet/icons/DropboxIntegrationIcon';

type Props = {
  provider: Provider;
  onIntegrationConnected: () => void;
};

const providerToIcon = {
  'gong': GongIntegrationIcon,
  'google-drive': GoogleDriveIntegrationIcon,
  'dropbox': DropboxIntegrationIcon,
  'microsoft-one-drive': GoogleDriveIntegrationIcon,
}

export const IntegrationConnectButton = ({
  provider,
  onIntegrationConnected,
}: Props) => {
  const receiveMessage = useCallback(
    (event) => {
      // Do we trust the sender of this message? (might be
      // different from what we originally opened, for example).
      const { data, isTrusted } = event;

      if (isTrusted && data) {
        onIntegrationConnected();
      }
      // if we trust the sender and the source is our popup
      // get the URL params and redirect to our server to use Passport to auth/login
    },
    []
  );

  const ProviderIcon = provider in providerToIcon ? providerToIcon[provider] : null;

  const integrationName = integrations.find((integration) => integration.code === provider)?.name;

  const onAddIntegration = useCallback(() => {
    openPopupWindow(`/oauth/${provider}`, `${provider}-oauth`, receiveMessage);
  }, [receiveMessage]);

  return (
    <NeueButtonBase
      onClick={onAddIntegration}
      className={classNames('py-[9px] px-4 text-neue-journey-fg')}
      baseColor={'rgb(var(--neue-journey-fg-10))'}
      gradientMaxOpacity={0.1}
    >
      <div className="flex items-center space-x-2">
        {ProviderIcon && <ProviderIcon className="w-5 h-5" />}
        <div>Connect {integrationName}</div>
      </div>
    </NeueButtonBase>
  )
};